import { auth } from '@/api'
import router from '@/router'
import Cookies from 'js-cookie'

// Function to logout the user
const logout = (context) => {
  Cookies.remove('token', { domain: process.env.DOMAIN })
  context.commit('LOGOUT') // Remove token from Vuex store
  const uri = `?redirect=${encodeURIComponent(window.location.href)}`
  window.location = `${process.env.AUTH_URL}${uri}` // Redirect to login page with current page in the query string
}

const loadUser = async ({ commit, dispatch }) => {
  let user
  try {
    user = (await auth.fetchUser()).data
  } catch (error) {
    error.response && dispatch('checkStatus', error.response.status)
  } finally {
    commit('USER_UPDATED', user)
  }
}

// Function to check if user is still logged in
const checkStatus = (context, status) => {
  if (status === 401) {
    logout(context) // Log out the user
  } else if (status === 403) {
    router.push({ name: 'forbidden' })
  }
  return false
}

export default {
  logout,
  loadUser,
  checkStatus
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js